import { render, staticRenderFns } from "./UiInputText.vue?vue&type=template&id=697cb975&scoped=true"
import script from "./UiInputText.vue?vue&type=script&lang=js"
export * from "./UiInputText.vue?vue&type=script&lang=js"
import style0 from "./UiInputText.vue?vue&type=style&index=0&id=697cb975&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697cb975",
  null
  
)

export default component.exports